import { z } from 'zod';
import type { DynamicFormField } from '@/features/dynamic-forms';
import { buildDynamicFormSchema } from '@/features/registration';

type T = (key: string) => string;

export const createBoxSchema = z.object({
  box_type_id: z.number().int().min(1),
  notes: z.string().max(5000).optional().nullable()
});

/**
 * Build the full box creation form schema: fixed fields + dynamic form fields.
 */
export function buildBoxFormSchema(fields: DynamicFormField[], t: T) {
  return z.object({
    box_type_id: z.coerce
      .number({ message: t('fieldRequired') })
      .positive(t('fieldRequired')),
    notes: z.string().max(5000).optional().nullable(),
    form_responses: buildDynamicFormSchema(fields, t)
  });
}

export const updateBoxSchema = z.object({
  notes: z.string().max(5000).optional().nullable(),
  security_seal_1: z.string().max(255).optional().nullable(),
  security_seal_2: z.string().max(255).optional().nullable()
});

export const updateBoxStatusSchema = z.object({
  status: z.enum([
    'available',
    'ready_for_shipping',
    'in_shipping',
    'in_transit',
    'received'
  ])
});

export const addContainerSchema = z.object({
  container_number: z.string().min(1)
});

export type CreateBoxFormValues = z.infer<typeof createBoxSchema>;
export type UpdateBoxFormValues = z.infer<typeof updateBoxSchema>;
export type UpdateBoxStatusFormValues = z.infer<typeof updateBoxStatusSchema>;
export type AddContainerFormValues = z.infer<typeof addContainerSchema>;
